import {
  Accounts_Details,
  DriverData,
  DriverNameData,
  FinantialYearData,
  GET_KEY_ACCOUNT_USER,
  GET_VEHICLES_DATA,
  GET_VEHICLE_LENGTH_MASTER,
  GetAllTableKey_Data_Query,
  GetBranches_WithCompany_code,
  GetCompanies,
  GetCompines_withLicence_code,
  GetLayoutNames,
  GetPercentage,
  GetVehicleType,
  GetVoucherSeries,
  HSNData,
  SEARCH_ACCOUNT_DATA_BY_ACCOUNT_TYPE,
  SEARCH_CITIES,
  SEARCH_CONNECTION_MEMO_UPDATION,
  SEARCH_PLACE_MASTER,
  SEARCH_QUERY,
  SEARCH_VEHICLE_OWNER_ACCOUNT,
  SearchAccount,
  SearchAccounts,
  SearchAccountsByProfileType,
  SearchCitiesEmt,
  SearchCityes,
  SearchContactPersonDataByID,
  SearchCustomerAccounts,
  SearchERPAddressBook,
  SearchEventCode_Master,
  SearchLRCenter,
  SearchModuleMaster,
  SearchPackagingMasterQuery,
  SearchPages,
  SearchServiceTypeMasterQuery,
  SearchStockGroupDropdownData,
  SearchTCS,
  SearchTDS,
  SearchTemplateWithTempleteCodeAndTempleteType,
  SearchTransportation,
  SearchVendorAccounts,
  Search_Accounts_By_Profile_Type,
  Search_Countries,
  Search_Districts,
  Search_States,
  Table_MasterData,
  TaxGroups,
  UsersSearchDropdownData,
  Zones,
  allAccountBalance,
  branchWithuserFilter,
  cities,
  getAccountContactInfo,
  getAllSubMenuSearch_WithMenuID,
  getFTL_CN_Details,
  getFormKeys,
  getFormSection,
  getLRReceipt_Details,
  getLR_Details,
  getStockItem,
  getUSerInfoByMobileNumber,
  getVoucherEnteriesByAccount,
  searchPriceList,
  searchWarehouseName,
  searchWarehouseNameWithoutBranch,
} from "../../../Utils/AllPagesQuriesAndMutations";

import AddFieldMaster from "../../Pages/FieldsMaster/AddFieldMaster";
import { GetLicensee_With_Search, GetLicensee_With_Search_value } from "../../Pages/LicenseRights/LicenseRights";
import {
  AddAccountGroup,
  AddBankAccount,
  AddBranch,
  AddCityMaster,
  AddCompany,
  AddConsignmentNote,
  AddCountryMaster,
  AddCustormerAccount,
  AddDistrictMaster,
  AddDriverAccount,
  AddFinancialMaster,
  AddHSN,
  AddLicense,
  AddLrCenter,
  AddMenuMaster,
  AddMyVehicleManagent,
  AddNominalAccount,
  AddPickupMemo,
  AddPlaceMaster,
  AddSalesInvoceType,
  AddStateMaster,
  AddStockGroup,
  AddStockItem,
  AddSubMenuMaster,
  AddTableKey,
  AddUserEntry,
  AddUserRole,
  AddTruckMaster,
  AddVehicleCategoryMaster,
  AddVehicleLengthMaster,
  AddVehicleManagent,
  AddVehicleTypeMaster,
  AddVendorAccount,
  AddVoucherSeries,
  AddWarehouseMaster,
  AddZoneMaster,
  AddLedger,
  AddVehicleOwnerAccount,
} from "../FormComponents";
import { AccountGroupData } from "../FormComponents/AddAccountGroup/AddAccountGroup.config";
import { getConnections } from "../FormComponents/AddConnectionMemoReceive/ConnectionMemoReceiveConfig";
import { VehicleData, gtPartData, gtPickupData } from "../FormComponents/AddConsignmentNote/AddConsignmentNoteConfig";
import AddContactPersonMaster from "../FormComponents/AddContactPersonMaster/AddContactPersonMaster";
import { AddERPAddressBookMaster } from "../FormComponents/AddERPAddressBookMaster/AddERPAddressBookMaster";
import AddFTLConsignmentNote from "../FormComponents/AddFTLConsignmentNote/AddFTLConsignmentNote";
import AddGeneralAccount from "../FormComponents/AddGeneralAccount/AddGeneralAccount";
import {
  getLPCSAccount,
  getLoadManagers,
  getMaterialCategory,
  getSPCSUsers,
} from "../FormComponents/AddLoad/AdddLoad.Config";
import AddMaterialCategory from "../FormComponents/AddMaterialCategory/AddMaterialCategory";
import {
  GetLength,
  SearchVehicleCategory_With_VechileMasters,
} from "../FormComponents/AddModelTypeMaster/AddModelTypeMasterSection/AddModelTypeMasterSection";
import { getLoadManagersForMyLoads } from "../FormComponents/AddMyLoad/AdddLoad.Config";
import { GET_VEHICLE_LENGTH } from "../FormComponents/AddMyVehicleManagent/AddMyVehicleManagent";
import { GetBranches } from "../FormComponents/AddPODManagement/AddPendingPODs/AddPendingPODs.config";
import AddPackagingMaster from "../FormComponents/AddPackagingMaster/AddPackagingMaster";
import AddPartMaster from "../FormComponents/AddPartMaster/AddPartMaster";
import AddPrintLayout from "../FormComponents/AddPrintLayout/AddPrintLayout";
import AddTCS from "../FormComponents/AddSalesBillSetup/AddTDSAndTSC/AddTCS";
import AddTDS from "../FormComponents/AddSalesBillSetup/AddTDSAndTSC/AddTDS";
import AddTaxGroup from "../FormComponents/AddSalesBillSetup/AddTaxGroup/AddTaxGroup";
import AddServiceTypeMaster from "../FormComponents/AddServiceTypeMaster/AddServiceTypeMaster";
import { GetModule } from "../FormComponents/AddSubMenuMaster/AddSubMenuMasterSection/AddSubMenuMasterSection";
import AddTaxPercentage from "../FormComponents/AddTaxPercentage/AddTaxPerCentage";
import { RolesData } from "../FormComponents/AddUserEntry/AddUserEntrySection/AddUserEntrySection";
import AddVehicelAccount from "../FormComponents/AddVehicelAccount/AddVehicelAccount";
import AddPageMaster from "../FormComponents/PageMaster/AddPageMaster";

export let AdditionalConfig = {
  District_Master: {
    addMaster: AddDistrictMaster,
    dropdowndata: Search_Districts,
    Form_Key: "District_Master",
  },
  State_Master: {
    addMaster: AddStateMaster,
    dropdowndata: Search_States,
    Form_Key: "State_Master",
  },
  Account_Group: {
    addMaster: AddAccountGroup,
    dropdowndata: AccountGroupData,
    Form_Key: "Account_Group",
  },
  Stock_Group: {
    addMaster: AddStockGroup,
    dropdowndata: SearchStockGroupDropdownData,
    Form_Key: "Stock_Group",
  },
  Event_Master: {
    dropdowndata: SearchEventCode_Master,
  },
  City_Master: {
    addMaster: AddCityMaster,
    dropdowndata: SearchCityes,
    Form_Key: "City_Master",
  },
  City_Search: {
    dropdowndata: SEARCH_CITIES,
  },
  Company: {
    addMaster: AddCompany,
    dropdowndata: GetCompanies,
    Form_Key: "Company",
  },
  Company_With_licenseeNo: {
    addMaster: AddCompany,
    dropdowndata: GetCompines_withLicence_code,
  },
  Select_Layout: {
    addMaster: AddPrintLayout,
    dropdowndata: GetLayoutNames,
  },
  Table_Master: {
    addMaster: AddTableKey,
    dropdowndata: Table_MasterData,
    Form_Key: "Emt_Table_Key",
  },
  User_Entry: {
    addMaster: AddUserEntry,
    dropdowndata: UsersSearchDropdownData,
    Form_Key: "User_Entry",
  },
  Driver_Account: {
    addMaster: AddDriverAccount,
    dropdowndata: DriverData,
    Form_Key: "Driver_Account",
  },
  Key_Account_Manager: {
    dropdowndata: GET_KEY_ACCOUNT_USER,
  },
  Page_Master: {
    addMaster: AddPageMaster,
    dropdowndata: SearchPages,
    Form_Key: "Page_Master",
  },
  Customer_Account: {
    addMaster: AddCustormerAccount,
    dropdowndata: SearchCustomerAccounts,
    EMTQuery: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    Form_Key: "Customer_Account",
  },
  Customer_Account_From_Account_Balance: {
    addMaster: AddCustormerAccount,
    dropdowndata: Accounts_Details,
    Form_Key: "Customer_Account",
  },
  Vendor_Account_From_Account_Balance: {
    addMaster: AddVendorAccount,
    dropdowndata: Accounts_Details,
    Form_Key: "Vendor_Account",
  },
  Cs_User: {
    dropdowndata: getLPCSAccount,
  },
  GoogleLocation: {
    dropdowndata: SEARCH_QUERY,
    EMTQuery: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  },
  LoadManager: {
    dropdowndata: getLoadManagers,
    EMTQuery: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  },
  MyLoadsLoadManager: {
    dropdowndata: getLoadManagersForMyLoads,
    EMTQuery: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  },
  SalesBillOFAccount: {
    dropdowndata: getVoucherEnteriesByAccount,
    EMTQuery: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  },
  SPCSUsers: {
    dropdowndata: getSPCSUsers,
  },
  // Vehicles: {
  //   dropdowndata: SearchVehicles,
  //   EMTQuery: {
  //     headers: { "X-GraphQL-Server": "secondary" },
  //   },
  // },
  SearchAccount: {
    dropdowndata: SearchAccount,
    EMTQuery: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  },

  UserByNumber: {
    dropdowndata: getUSerInfoByMobileNumber,
  },

  Material_Category: {
    dropdowndata: getMaterialCategory,
    addMaster: AddMaterialCategory,
    EMTQuery: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    Form_Key: "Material_Category",
  },
  Vehicle_Type: {
    dropdowndata: GetVehicleType,
    addMaster: AddVehicleTypeMaster,
    Form_Key: "Truck_Master",
  },
  Vehicle_Length: {
    dropdowndata: GetLength,
    addMaster: AddVehicleLengthMaster,
    Form_Key: "Vehicle_Length",
  },
  Vehicle_Category: {
    dropdowndata: SearchVehicleCategory_With_VechileMasters,
    addMaster: AddVehicleCategoryMaster,
    Form_Key: "Vehicle_Category",
  },
  user_Branch: {
    dropdowndata: branchWithuserFilter,
    addMaster: AddBranch,
    Form_Key: "Branch",
  },
  Branch: {
    dropdowndata: GetBranches,
    addMaster: AddBranch,
    Form_Key: "Branch",
  },
  // GetBranches_WithCompany_code
  GetBranches_WithCompany_code: {
    dropdowndata: GetBranches_WithCompany_code,
    addMaster: AddBranch,
    Form_Key: "Branch",
  },
  HSN_Code: {
    dropdowndata: HSNData,
    addMaster: AddHSN,
    Form_Key: "HSN_Code",
  },
  Voucher_Series: {
    dropdowndata: GetVoucherSeries,
    addMaster: AddVoucherSeries,
    Form_Key: "Voucher_Series",
  },
  General_Account: {
    dropdowndata: Accounts_Details,
    addMaster: AddGeneralAccount,
    Form_Key: "General_Account",
  },
  Zone: {
    dropdowndata: Zones,
    addMaster: AddZoneMaster,
    Form_Key: "Zone_Master",
  },
  Country: {
    dropdowndata: Search_Countries,
    addMaster: AddCountryMaster,
    Form_Key: "Country_Master",
  },
  Search_Vehicle_Owner_Account: {
    dropdowndata: SEARCH_VEHICLE_OWNER_ACCOUNT,
    addMaster: AddVehicleOwnerAccount,
    Form_Key: "Vehicle_Owner_Account",
  },
  Menu: {
    dropdowndata: GetModule,
    addMaster: AddMenuMaster,
    Form_Key: "Menu_Master",
  },

  Role: {
    dropdowndata: RolesData,
    addMaster: AddUserRole,
    Form_Key: "User_Role",
  },

  Vehicle_length: {
    dropdowndata: GET_VEHICLE_LENGTH_MASTER,
    addMaster: AddVehicleLengthMaster,
  },

  Vehicle_length_Merge: {
    dropdowndata: GET_VEHICLE_LENGTH,
    addMaster: AddVehicleLengthMaster,
  },

  SubMenu: {
    dropdowndata: getAllSubMenuSearch_WithMenuID,
    addMaster: AddSubMenuMaster,
    Form_Key: "Sub_Menu",
  },
  Module: {
    dropdowndata: SearchModuleMaster,
  },
  Vendor_Account: {
    dropdowndata: SearchVendorAccounts,
    addMaster: AddVendorAccount,
    Form_Key: "Vendor_Account",
  },
  All_Accounts: {
    dropdowndata: Accounts_Details,
    addMaster: AddLedger,
    Form_Key: "Account_Vouchers",
  },
  Bank_And_Cash_Accounts: {
    dropdowndata: Accounts_Details,
    addMaster: AddBankAccount,
    Form_Key: "Bank_Cash_Account",
  },
  CS_Vendor_Accounts: {
    dropdowndata: SearchAccounts,
    addMaster: AddVendorAccount,
    Form_Key: "Vendor_Account",
  },
  AllAccountBalance: {
    dropdowndata: allAccountBalance,
  },
  SearchAccountByProfileType: {
    dropdowndata: SearchAccountsByProfileType,
    EMTQuery: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  },
  SearchCitiesEmt: {
    dropdowndata: SearchCitiesEmt,
    EMTQuery: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  },
  Search_Accounts_By_Profile_Type: {
    dropdowndata: Search_Accounts_By_Profile_Type,
    EMTQuery: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  },
  Vehicles: {
    dropdowndata: GET_VEHICLES_DATA,
    addMaster: AddVehicleManagent,
    EMTQuery: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    Form_Key: "Vehicle_Management",
  },
  My_Vehicles: {
    dropdowndata: GET_VEHICLES_DATA,
    addMaster: AddMyVehicleManagent,
    EMTQuery: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    Form_Key: "My_Vehicle_Management",
  },
  Licensee: {
    dropdowndata: GetLicensee_With_Search,
    addMaster: AddLicense,
    Form_Key: "Licensee_Master",
  },
  Licensee_Search_value: {
    dropdowndata: GetLicensee_With_Search_value,
    addMaster: AddLicense,
  },
  VehicleData: {
    dropdowndata: VehicleData,
    addMaster: AddTruckMaster,
    Form_Key: "Truck_Master",
  },
  SalesInvoiceType: {
    dropdowndata: TaxGroups,
    addMaster: AddTaxGroup,
    Form_Key: "Tax_Group",
  },
  TableKeys: {
    dropdowndata: GetAllTableKey_Data_Query,
    addMaster: AddFieldMaster,
    Form_Key: "Add_Field_Master",
  },
  gtPartData: {
    dropdowndata: gtPartData,
    addMaster: AddPartMaster,
    Form_Key: "Part_Master_Data",
  },
  // SearchTransportation
  searchTransportModeData: {
    dropdowndata: SearchTransportation,
    addMaster: AddVehicelAccount,
    Form_Key: "Truck_Master",
  },
  gtPickupData: {
    dropdowndata: gtPickupData,
    addMaster: AddPickupMemo,
    Form_Key: "Pickup_Memo",
  },
  searchPackaging: {
    dropdowndata: SearchPackagingMasterQuery,
    addMaster: AddPackagingMaster,
    Form_Key: "Packaging_Data",
  },
  ServiceTypeData: {
    dropdowndata: SearchServiceTypeMasterQuery,
  },
  DriverNameData: {
    dropdowndata: DriverNameData,
    addMaster: AddDriverAccount,
    Form_Key: "Driver_Account",
  },

  GetConnectionMemoUpdation: {
    dropdowndata: SEARCH_CONNECTION_MEMO_UPDATION,
  },
  Get_Lr_Details: {
    // getLR_Details
    dropdowndata: getLR_Details,
  },

  Get_Lr_Receipt_Details: {
    // getLR_Details
    dropdowndata: getLRReceipt_Details,
    addMaster: AddConsignmentNote,
    Form_Key: "Consignment_Note",
  },
  Get_FTL_CN_Details: {
    // getLR_Details
    dropdowndata: getFTL_CN_Details,
    addMaster: AddFTLConsignmentNote,
    Form_Key: "FTL_Consignment_Note",
  },
  Customer_Account_For_CN: {
    dropdowndata: SearchCustomerAccounts,
    addMaster: AddCustormerAccount,
    Form_Key: "Customer_Account",
  },
  getConnections: {
    dropdowndata: getConnections,
  },
  AccountContactPerson: {
    dropdowndata: SearchContactPersonDataByID,
    addMaster: AddContactPersonMaster,
    Form_Key: "Contact_Person_Master",
  },
  LR_Center_Data: {
    dropdowndata: SearchLRCenter,
    addMaster: AddLrCenter,
    Form_Key: "LR_Center_Master_Data",
  },
  StockItem: {
    dropdowndata: getStockItem,
    addMaster: AddStockItem,
    Form_Key: "Stock_Item",
  },
  Warehouse_Name: {
    dropdowndata: searchWarehouseName,
    addMaster: AddWarehouseMaster,
    Form_Key: "Warehouse_Master",
  },
  Warehouse_Name_Without_Branch: {
    dropdowndata: searchWarehouseNameWithoutBranch,
    addMaster: AddWarehouseMaster,
    Form_Key: "Warehouse_Master",
  },
  getAccountsToAddContact: {
    dropdowndata: getAccountContactInfo,
  },
  SearchUserAccountsForBill: {
    dropdowndata: SEARCH_ACCOUNT_DATA_BY_ACCOUNT_TYPE,
    addMaster: AddCustormerAccount,
    Form_Key: "Customer_Account",
  },
  SearchUserAccountsForTransporter: {
    dropdowndata: SEARCH_ACCOUNT_DATA_BY_ACCOUNT_TYPE,
    addMaster: AddVendorAccount,
    Form_Key: "Vendor_Account",
  },
  ERPAddressBook: {
    dropdowndata: SearchERPAddressBook,
    addMaster: AddERPAddressBookMaster,
    Form_Key: "ERP_Address_Book_Master",
  },
  TaxPercentage: {
    dropdowndata: GetPercentage,
    addMaster: AddTaxPercentage,
    Form_Key: "Tax_Percentage",
  },
  SearchCities: {
    dropdowndata: SearchCitiesEmt,
  },
  SearchPlaceMaster: {
    // getLR_Details
    dropdowndata: SEARCH_PLACE_MASTER,
    addMaster: AddPlaceMaster,
    Form_Key: "Place_Master",
    EMTQuery: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  },
  Financial_Year_Master: {
    dropdowndata: FinantialYearData,
    addMaster: AddFinancialMaster,
    Form_Key: "Financial_Master",
  },
  TDSMaster: {
    dropdowndata: SearchTDS,
    addMaster: AddTDS,
    Form_Key: "TDS",
  },
  TCSMaster: {
    dropdowndata: SearchTCS,
    addMaster: AddTCS,
    Form_Key: "TCS",
  },
  Email_Template: {
    dropdowndata: SearchTemplateWithTempleteCodeAndTempleteType,
  },
  form_Keys: {
    dropdowndata: getFormKeys,
  },
  form_Sections: {
    dropdowndata: getFormSection,
  },
  City_Master_For_Merge: {
    dropdowndata: cities,
  },
  Search_Price_Lists: {
    dropdowndata: searchPriceList,
  },
};

// Branch_code_query
